import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { endOfDay, startOfDay } from "date-fns";

/** Converts a [start, end] date-input range into ISO start/end params. */
export function toIsoDateRange(value) {
  var _value = _slicedToArray(value, 2),
    start = _value[0],
    end = _value[1];
  if (!start || !end) return {};
  var startDate = new Date(start);
  var endDate = new Date(end);
  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return {};
  return {
    start_date: startOfDay(startDate).toISOString(),
    end_date: endOfDay(endDate).toISOString()
  };
}